import React, { useEffect } from "react";
import PropTypes from "prop-types";

const toastStyles = {
  error: {
    container: "bg-error",
    icon: "icon-notice",
    title: "Bet Error",
  },
  warning: {
    container: "bg-warning",
    icon: "icon-notifications",
    title: "Warning",
  },
  success: {
    container: "bg-success",
    icon: "icon-check-circle",
    title: "Success",
  },
  info: {
    container: "bg-info",
    icon: "icon-info",
    title: "Info",
  },
};

const NewToast = ({ type = "error", title, message, onClose }) => {
  const { container, icon, title: defaultTitle } =
    toastStyles[type] || toastStyles.error;

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose?.();
    }, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div data-v-fa12c4fa>
      {/* Overlay */}
      <div
        className="absolute left-0 top-0 w-full h-full z-50"
        data-testid="toast-overlay"
        data-v-fa12c4fa
        onClick={onClose}
      />

      {/* Toast Container */}
      <div
        className="fixed bottom-0 z-50 w-full space-y-2.5"
        data-v-fa12c4fa
      >
        <div data-v-fa12c4fa>
          <div
            className={`text-center flex rounded-t-2xl justify-center p-1 ${container}`}
            data-testid="toast-container"
            data-v-fa12c4fa
          >
            <div className="w-full" data-v-fa12c4fa>
              {/* Header */}
              <div
                className="flex justify-center items-center text-global-font-on-dark font-bold py-2 mb-1 relative"
                data-v-fa12c4fa
              >
                <i
                  className={`text-global-font-on-dark text-16 ${icon}`}
                  data-testid="toast-icon-title"
                  data-v-fa12c4fa
                />
                <h4
                  className="ml-1 leading-none text-13"
                  data-testid="toast-title"
                  data-v-fa12c4fa
                >
                  {title || defaultTitle}
                </h4>
                <div
                  onClick={onClose}
                  className="icon-close absolute right-5 text-14 cursor-pointer"
                  data-testid="toast-btn-close-toast"
                  data-v-fa12c4fa
                />
              </div>

              {/* Message */}
              <div
                className="px-2 py-4 rounded-lg bg-white bg-opacity-87 text-13 text-global-font-on-light"
                data-testid="toast-content"
                data-v-fa12c4fa
              >
                {message}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

NewToast.propTypes = {
  type: PropTypes.oneOf(["error", "warning", "success", "info"]),
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func,
};

export default NewToast;
